export const DAYS = [
  { label: 'Ma', value: 1 },
  { label: 'Ti', value: 2 },
  { label: 'Ke', value: 3 },
  { label: 'To', value: 4 },
  { label: 'Pe', value: 5 },
  { label: 'La', value: 6 },
  { label: 'Su', value: 0 },
];

export const TASK_ICONS = [
  '📋','🧹','🧺','🍽️','🛁','🚿','🪣','🧴','🧻','🛏️',
  '🧽','🪟','🗑️','🧼','🪠','🧲','🔑','🛋️','🪑','🚪',
  '🪴','🌿','🌸','🌻','🌈','🌙','⭐','🌟','🌅','☀️',
  '🥗','🍳','🍎','🍌','🥕','🥛','🍪','🧁','🍕','🍔','🥤','🍦','🍴','🥩',
  '📚','🎒','✏️','📖','🎓','💡','🔬','🧮','📐','✨',
  '🎨','🎵','🎪','🎯','🏆','🎖️','🎁','🎈','🎉','🎊','🎀','🧩','🪁','🧸','🎮','🎲','⛸️','🎃',
  '🦷','👕','🧦','🪥','💊','💤',
  '⚽','🏀','🚴','🏃','🧘','🎾','🏊','🚗',
  '🐈','😺','😻','😹','🙀','🐶','🐕',
  '🤣','❤️','😍','😒','🫡','🤑','😭','😵','🥵','🥶','😈','💩',
  '👮','👮‍♀️','🤶','🧚‍♀️',
  '🔒','⚠️','✅','❌','💰','📦',
];

export const emptyForm = {
  title: '', description: '', assigned_to: [],
  recurrence_type: 'once', recurrence_days: [],
  reward_points: 1, cooldown_days: 0, is_active: true,
  icon: '', is_locked: false, time_start: '', time_end: '',
  task_type: 'always', category: '', requires_approval: false,
  scheduled_date: '',
  recurrence_interval: 1, recurrence_end_type: 'never',
  recurrence_end_date: '', recurrence_end_count: '',
  max_claims: '',
};

export const TASK_PRESETS = [
  { title: 'Aamurutiini', icon: '🌅' },
  { title: 'Syö aamupalaa', icon: '🍳' },
  { title: 'Pue päälle', icon: '👕' },
  { title: 'Pese hampaat', icon: '🪥' },
  { title: 'Pese kädet', icon: '🧼' },
  { title: 'Suihkupäivä', icon: '🚿' },
  { title: 'Kylpypäivä', icon: '🛁' },
  { title: 'Vie astiat koneeseen', icon: '🍽️' },
  { title: 'Kata pöytä', icon: '🍴' },
  { title: 'Auta ruoanlaitossa', icon: '🧑‍🍳' },
  { title: 'Viikkaa vaatteet', icon: '👚' },
  { title: 'Tyhjennä pyykkikori', icon: '🧺' },
  { title: 'Tyhjennä tiskikone', icon: '🫧' },
  { title: 'Lue kirja', icon: '📖' },
  { title: 'Ruoki lemmikki', icon: '🐾' },
  { title: 'Leiki sisaren kanssa', icon: '🤝' },
  { title: 'Tee kotitehtävät', icon: '📝' },
  { title: 'Tee aamuliikunta', icon: '🏃' },
  { title: 'Laita kengät siististi', icon: '👟' },
  { title: 'Petaa sänky', icon: '🛏️' },
  { title: 'Siivoa leikki', icon: '🧸' },
  { title: 'Siivoa huone', icon: '🧹' },
  { title: 'Siivoa pöytä', icon: '🪣' },
  { title: 'Vie roskat', icon: '🗑️' },
  { title: 'Imuroi lattia', icon: '🧹' },
  { title: 'Järjestele työpöytä', icon: '🗂️' },
  { title: 'Järjestele lelut', icon: '📦' },
];

export const parseRecurrencePattern = (task) => {
  try {
    const p = task.recurrence_pattern
      ? (typeof task.recurrence_pattern === 'string' ? JSON.parse(task.recurrence_pattern) : task.recurrence_pattern)
      : {};
    return {
      recurrenceDays: p.days || [],
      recurrenceInterval: p.interval || 1,
      recurrenceEndType: p.end_type || 'never',
      recurrenceEndDate: p.end_date || '',
      recurrenceEndCount: p.end_count || '',
    };
  } catch {
    return { recurrenceDays: [], recurrenceInterval: 1, recurrenceEndType: 'never', recurrenceEndDate: '', recurrenceEndCount: '' };
  }
};
